import React from 'react';

import { View } from './View';
import { List } from './List';

export const projectsRoutes = {
  path: '/projects',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id/view',
      element: <View />,
    },
  ],
};
